// extracted by mini-css-extract-plugin
export default {"wrapper":"orderJSON_wrapper__-W2D4","date":"orderJSON_date__KTHLG","orders":"orderJSON_orders__XbkJY","order":"orderJSON_order__W0End","product":"orderJSON_product__Goitp"};